import type { PointLink } from './point.types';

class PointServiceClass {
    private readonly ExternalPrefix = 'https://';
    private readonly ExternalTarget = '_blank';
    private readonly ExternalRel = 'noopener noreferrer';

    /**
     * The one link derivation for NavPoint and DropdownPoint.
     * An empty or missing href means "no link".
     */
    public buildLink(href: string | undefined): PointLink {
        const Url = (href ?? '').trim();
        const HasLink = Url !== '';
        const Target = HasLink && Url.startsWith(this.ExternalPrefix) ? this.ExternalTarget : undefined;

        return {
            url: Url,
            hasLink: HasLink,
            target: Target,
            rel: Target === undefined ? undefined : this.ExternalRel,
        };
    }
}

export const PointService = new PointServiceClass();
